import { render } from "./AsHeaderMain.vue?vue&type=template&id=54714ea0&ts=true"
import script from "./AsHeaderMain.vue?vue&type=script&lang=ts"
export * from "./AsHeaderMain.vue?vue&type=script&lang=ts"

import "./AsHeaderMain.vue?vue&type=style&index=0&id=54714ea0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__